export function resolveUploadSubmissionIdentifier(
  submissionIdentifier,
  uploadTemplateList,
  useSubmitTemplateName,
) {
  const templateLob = uploadTemplateList[0].split("-")[0];
  if (
    templateLob.toLowerCase() ===
    submissionIdentifier.split("-")[0].toLowerCase()
  ) {
    return submissionIdentifier;
  }
  // Preserve the existing default-template prefix casing and entered ID casing.
  const prefix = useSubmitTemplateName
    ? templateLob.toLowerCase()
    : templateLob;
  return `${prefix}-${submissionIdentifier}`;
}
